<template>
  <div class="col-md-8 col-lg-8 right-container forms-container d-flex register-form">
    <div class="text-center height-register">
      <h3> اهلا بك </h3>
      <p>املأ البيانات المطلوبة لتستمتع برحلتك في عالم جيو أحمد مكاوي</p>
      <form @submit.prevent="handleSubmit">
        <div class="form-group d-flex flex-column">
          <input
            placeholder="الاسم الاول للطالب "
            type="text"
            id="first-name"
            pattern="[\u0600-\u06FF\s]+"
            title="برجاء ادخال حروف عربية فقط غير مسموح باللغة الانجليزية او اي علامات اخرى"
            oninput="this.value = this.value.replace(/[^\u0600-\u06FF\s]/g, '')"
            v-model="form.firstName"
            required
          />
          <div v-if="errors.first_name" class="text-danger">{{ errors.first_name }}</div>

          <input
            placeholder=" الاسم الثاني للطالب"
            type="text"
            id="middle-name"
            v-model="form.middleName"
            pattern="[\u0600-\u06FF\s]+"
            title="برجاء ادخال حروف عربية فقط غير مسموح باللغة الانجليزية او اي علامات اخرى"
            oninput="this.value = this.value.replace(/[^\u0600-\u06FF\s]/g, '')"
            required
          />
          <div v-if="errors.middle_name" class="text-danger">{{ errors.middle_name }}</div>

          <input
            placeholder=" اسم العائلة للطالب"
            type="text"
            id="last-name"
            v-model="form.lastName"
            pattern="[\u0600-\u06FF\s]+"
            title="برجاء ادخال حروف عربية فقط غير مسموح باللغة الانجليزية او اي علامات اخرى"
            oninput="this.value = this.value.replace(/[^\u0600-\u06FF\s]/g, '')"
            required
          />
          <div v-if="errors.last_name" class="text-danger">{{ errors.last_name }}</div>

          <input
            placeholder="رقم الهاتف"
            type="text"
            id="phone-number"
            v-model="form.phoneNumber"
            @input="handlePhoneNumberInput('phoneNumber')"
            required
          />
          <div v-if="errors.phone" class="text-danger">{{ errors.phone }}</div>
          <div v-if="arabicNumbersError.phone" class="text-danger">
            برجاء كتابة الأرقام باللغة الإنجليزية فقط.
          </div>

          <input
            placeholder="رقم هاتف ولي الأمر"
            type="text"
            id="parent-phone-number"
            v-model="form.parentPhoneNumber"
            @input="handlePhoneNumberInput('parentPhoneNumber')"
            required
          />
          <div v-if="errors.father_phone" class="text-danger">{{ errors.father_phone }}</div>
          <div v-if="arabicNumbersError.parentPhone" class="text-danger">
            برجاء كتابة الأرقام باللغة الإنجليزية فقط.
          </div>
          <!-- المحافظة -->
          <select id="location" v-model="form.location_id" required>
            <option disabled value="">المحافظة</option>
            <option v-for="location in locations" :key="location.id" :value="location.id">
              {{ location.name }}
            </option>
          </select>
          <div v-if="errors.location_id" class="text-danger">{{ errors.location_id }}</div>

          <!-- المرحلة التعليمية -->
          <select id="stage" v-model="form.education_stage_id" required>
            <option disabled value="">المرحلة التعليمية</option>
            <option v-for="stage in stages" :key="stage.id" :value="stage.id">
              {{ stage.name }}
            </option>
          </select>
          <div v-if="errors.education_stage_id" class="text-danger">{{ errors.education_stage_id }}</div>

          <select id="grade" v-model="form.grade_id" required>
            <option disabled value="">الصف الدراسي</option>
            <option v-for="grade in grades" :key="grade.id" :value="grade.id">
              {{ grade.name }}
            </option>
          </select>
          <div v-if="errors.grade_id" class="text-danger">{{ errors.grade_id }}</div>

          <input
            placeholder="كلمة المرور"
            type="password"
            id="password"
            v-model="form.password"
            required
          />
          <div v-if="errors.password" class="text-danger">{{ errors.password }}</div>
          <div v-if="form.password.length > 0 && form.password.length < 8" class="text-danger">
            The password must be at least 8 characters.
          </div>

          <input
            placeholder="تأكيد كلمة المرور"
            type="password"
            id="password-confirm"
            v-model="form.passwordConfirm"
            required
          />
          <div v-if="form.password !== form.passwordConfirm" class="text-danger">
            Passwords do not match
          </div>
        </div>

        <div class="form-group btn-form-container">
          <button type="submit" class="btn btn-block orange-btn">إنشاء حساب</button>
        </div>

        <div class="text-center mt-3">
          <p>
            لديك حساب ؟
            <router-link to="/login" style="color: #FFF; font-weight: 600;">تسجيل دخول</router-link>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import apiService from '../apiService';

export default {
  name: 'RegisterForm',
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        middleName: '',
        phoneNumber: '',
        parentPhoneNumber: '',
        location_id: '',
        education_stage_id: '',
        grade_id: '',
        password: '',
        passwordConfirm: '',
      },
      errors: {}, 
      locations: [],
      stages: [],
      grades: [],
      arabicNumbersError: {
        phone: false,
        parentPhone: false
      }
    };
  },
  created() {
    this.fetchLocations();
    this.fetchStages();
  },
  computed: {
    phoneNumbersMatch() {
      return this.form.phoneNumber && this.form.parentPhoneNumber && this.form.phoneNumber === this.form.parentPhoneNumber;
    }
  },
  methods: {
    ...mapActions(['registerUser']),
    async fetchLocations() {
      try {
        const response = await apiService.getLocations();
        if (response && response.data) {
          this.locations = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching locations', error);
      }
    },
    async fetchStages() {
      try {
        const response = await apiService.getStages();
        this.stages = response.data.stages || response.data.data || [];
      } catch (err) {
        console.error("خطأ في جلب المراحل", err);
      }
    },
    handlePhoneNumberInput(field) {
      const hasArabic = /[\u0660-\u0669\u06F0-\u06F9]/.test(this.form[field]);

      if (hasArabic) {
        if (field === 'phoneNumber') {
          this.arabicNumbersError.phone = true;
        } else {
          this.arabicNumbersError.parentPhone = true;
        }
        this.form[field] = this.form[field].replace(/[\u0660-\u0669\u06F0-\u06F9]/g, '');
      } else {
        if (field === 'phoneNumber') {
          this.arabicNumbersError.phone = false;
        } else {
          this.arabicNumbersError.parentPhone = false;
        }
        this.form[field] = this.form[field].replace(/[^\d]/g, '');
      }
    },
    async handleSubmit() {
      this.errors = {}; 

      if (this.form.password.length > 0 && this.form.password.length < 8) {
        this.errors.password = ['The password must be at least 8 characters.'];
      }
      if (this.form.password !== this.form.passwordConfirm) {
        this.errors.password_confirmation = ['Passwords do not match'];
      }
      if (this.phoneNumbersMatch) {
        this.errors.father_phone = ['رقم هاتف ولي الأمر يجب أن يكون مختلفًا عن رقم هاتف الطالب.'];
      }
      try {
        const payload = {
          first_name: this.form.firstName,
          last_name: this.form.lastName,
          middle_name: this.form.middleName,
          phone: this.form.phoneNumber,
          father_phone: this.form.parentPhoneNumber,
          location_id: this.form.location_id,
          education_stage_id: this.form.education_stage_id,
          grade_id: this.form.grade_id,
          password: this.form.password,
          password_confirmation: this.form.passwordConfirm,
        };
        await this.registerUser(payload); 
        if (!Object.keys(this.errors).length) {
          this.$router.push('/profile'); 
        }
      } catch (error) {
        console.error('Error submitting form', error);
        if (error.response && error.response.data && error.response.data.errors) {
          this.errors = error.response.data.errors; 
        }
      }
    },
  },
  watch: {
    'form.education_stage_id': {
      immediate: true,
      async handler(newValue) {
        this.form.grade_id = '';
        if (newValue) {
          try {
            const res = await apiService.getGradesByStage(newValue);
            this.grades = res.data.grades || res.data.data || [];
          } catch (err) {
            console.error("خطأ في جلب الصفوف", err);
          }
        } else {
          this.grades = [];
        }
      }
    }
}
};
</script>


<style scoped>
.register-form{
  padding-top: 145px;
}
.text-center.mt-3 p a {
  color: #FFF;
  font-weight: 600;
}

select {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: 'Cairo', sans-serif;
}

.text-danger {
  color: rgb(250, 175, 67) !important;
  font-size: 12px;
  background: #fff;
  padding: 4px;
  border-radius: 5px;
}

.height-register {
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media screen {
  .forms-container p , .forms-container  h3{
    margin-right: 20px;
  }
}
</style>